<template>
<div>

    <CCard>
        <CCardHeader color="primario" text-color="white">
            <i class="fas fa-edit fa-md"></i> <span class="h5"> Gestión de incidencias </span>
        </CCardHeader>
        <CCardBody>
            <b-row>
                <b-col md="12">
                    <validation-observer ref="observer" v-slot="{ handleSubmit }">
                        <b-form @submit.stop.prevent="handleSubmit(registrarIncidencia)">
                            <b-tabs content-class="mt-3" active-nav-item-class="font-weight-bold text-uppercase text-dark">
                                <b-tab title="Datos generales" active>
                                    <b-row>
                                        <b-col md="2">
                                            <validation-provider name="fecha" :rules="{ required: true }" v-slot="validationContext">
                                                <b-form-group label="Fecha:" class="mb-2">
                                                    <b-form-input type="date" :state="getValidationState(validationContext)" placeholder="Ingrese la fecha" v-model="datosIncidencia.fecha"></b-form-input>
                                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col md="3">
                                            <!-- <validation-provider name="n°" :rules="{ required: true }" v-slot="validationContext">
                                                <b-form-group label="N°:" class="mb-2">
                                                    <b-form-input :state="getValidationState(validationContext)" placeholder="Ingrese el número" v-model="datosIncidencia.numero"></b-form-input>
                                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider> -->
                                            <validation-provider name="número" :rules="{required: true}" v-slot="validationContext">
                                                <b-form-group label="Número:" class="mb-2">
                                                    <b-input-group>
                                                        <b-form-input type="number"  :state="getValidationState(validationContext)" placeholder="Ingrese el número" v-model="datosIncidencia.numero"></b-form-input>
                                                        <b-input-group-append>
                                                            <b-input-group-text>/ 20</b-input-group-text>
                                                        </b-input-group-append>
                                                        <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                    </b-input-group>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col md="3">
                                            <validation-provider name="norma" rules="required" v-slot="{errors}">
                                                <b-form-group label="Norma:" class="mb-2">
                                                    <v-select label="descripcion" :reduce="comboNorma =>comboNorma.idNorma" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosIncidencia.norma , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosIncidencia.norma" :options="comboNorma" @search:blur="blurNorma">
                                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                                    </v-select>
                                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col md="4" v-if="datosIncidencia.norma != 1 && datosIncidencia.norma">
                                            <validation-provider name="tipo" rules="required" v-slot="{errors}">
                                                <b-form-group label="Tipo:" class="mb-2">
                                                    <v-select label="descripcion" :reduce="comboTipo =>comboTipo.idTipo" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosIncidencia.tipo , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosIncidencia.tipo" :options="comboTipo" @search:blur="blurTipo">
                                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                                    </v-select>
                                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col md="6">
                                            <validation-provider name="categoria" rules="required" v-slot="{errors}">
                                                <b-form-group label="Categoría:" class="mb-2">
                                                    <v-select label="nombre" :reduce="comboCategoria =>comboCategoria.idCategoriaIncidente" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosIncidencia.categoria , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosIncidencia.categoria" :options="comboCategoria" @search:blur="blurCategoria">
                                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                                    </v-select>
                                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col md="6">
                                            <validation-provider name="proceso" rules="required" v-slot="{errors}">
                                                <b-form-group label="Proceso afectado:" class="mb-2">
                                                    <v-select label="nombre" :reduce="comboProceso =>comboProceso.idProceso" placeholder="Seleccione una opción" :class=" {'style-valid-select': datosIncidencia.idProceso , 'style-invalid-select is-invalid': !!errors.length}" v-model="datosIncidencia.idProceso" :options="comboProceso" @search:blur="blurProceso">
                                                        <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                                    </v-select>
                                                    <div class="invalid-feedback">{{ errors[0]}}</div>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col md="2" class="text-center">
                                            <b-form-group label="Resueltas: " class="my-2">
                                                <b-form-radio-group small plain v-model="datosIncidencia.isResuelta" :options="radioResueltas"></b-form-radio-group>
                                            </b-form-group>
                                        </b-col>

                                        <b-col v-if="datosIncidencia.isResuelta==2" md="4">
                                            <validation-provider name="fecha de resolución" :rules="{ required: true }" v-slot="validationContext">
                                                <b-form-group label="Fecha de resolución:" class="mb-2">
                                                    <b-form-input type="date" :state="getValidationState(validationContext)" placeholder="Ingrese la fecha de resolución" v-model="datosIncidencia.fechaResolucion"></b-form-input>
                                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col v-else md="4"></b-col>
                                        <b-col md="6">
                                            <validation-provider name="persona que detectó" :rules="{ required: true }" v-slot="validationContext">
                                                <b-form-group label="Persona que detecta la incidencia:" class="mb-2">
                                                    <b-form-input type="text" :state="getValidationState(validationContext)" placeholder="Ingrese la persona" v-model="datosIncidencia.personaDetecta"></b-form-input>
                                                    <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>
                                        <b-col md="6">
                                            <validation-provider name="descripción" v-slot="validationContext">
                                                <b-form-group label="Descripción:" class="mb-2">
                                                    <b-form-textarea v-model="datosIncidencia.descripcion" placeholder="Ingrese la descripción" rows="4" max-rows="6" :state="getValidationState(validationContext)"></b-form-textarea>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                        <b-col md="6">
                                            <validation-provider name="observaciones" v-slot="validationContext">
                                                <b-form-group label="Observaciones:" class="mb-2">
                                                    <b-form-textarea v-model="datosIncidencia.observacion" placeholder="Ingrese las observaciones" rows="4" max-rows="6" :state="getValidationState(validationContext)"></b-form-textarea>
                                                </b-form-group>
                                            </validation-provider>
                                        </b-col>

                                    </b-row>
                                </b-tab>
                                <b-tab title="Evidencias">
                                    <b-row>
                                        <b-col md="12">
                                            <CButton size="sm" color="dark" class="float-right" @click="agregarEvidencias()">
                                                <i class="fas fa-plus fa-sm"></i> Agregar
                                            </CButton>
                                        </b-col>
                                        <b-col md="12 my-2">
                                            <b-table :items="listaIncidenciasEvidencias.filter(x => x.estado == 2)" :fields="camposEvidencias" class="table-custom" show-empty mediun responsive outlined fixed hover empty-text="Aún no hay datos en esta sección.">
                                                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                                <template v-slot:cell(nombre)="data">
                                                    <validation-provider :name="'nombre'+data.index" :rules="{ required: true }" v-slot="validationContext">
                                                        <b-form-input placeholder="Ingrese nombre" type="text" :state="getValidationState(validationContext)" v-model="data.item.nombre"></b-form-input>
                                                    </validation-provider>
                                                </template>
                                                <template v-slot:cell(documento)="row">
                                                    <b-input-group v-if="row.item.urlArchivo !== null && row.item.urlArchivo != ''">
                                                        <b-input-group-prepend>
                                                            <b-button variant="dark" class="px-2 py-0" @click="descargarDocumento(row.item.urlArchivo)" v-c-tooltip="'Descargar'">
                                                                <i class="fas fa-download fa-xs"></i>
                                                            </b-button>
                                                        </b-input-group-prepend>
                                                        <b-form-file class="text-left" :ref="'filex'+row.index" v-model="row.item.documento" :placeholder="row.item.nombreArchivo" drop-placeholder="Arrastre el documento aquí.." :accept="accept.toString()" browse-text="Subir" v-on:change="handlexFileUpload($event,row.index)"></b-form-file>
                                                    </b-input-group>
                                                    <b-form-file class="text-left" v-else :ref="'filex'+row.index" v-model="row.item.documento" v-on:change="handlexFileUpload($event,row.index)" placeholder="Elija un archivo o arrástrelo aquí..." drop-placeholder="Arrastre el documento aquí.." browse-text="Subir" :accept="accept.toString()"></b-form-file>
                                                </template>

                                                <template v-slot:cell(opciones)="param">
                                                    <b-button v-if="param" size="sm" variant="danger" v-c-tooltip.hover.click="'Eliminar'" @click="eliminarEvidencia(param)">
                                                        <i class="fas fa-trash-alt  my-0 mx-0"></i>
                                                    </b-button>
                                                </template>
                                            </b-table>
                                        </b-col>
                                    </b-row>
                                </b-tab>

                                <b-tab title="No Conformidades vinculadas">
                                    <b-row>
                                        <b-col md="12">
                                            <CButton size="sm" color="dark" class="float-right" @click="agregarNoConformidades()">
                                                <i class="fas fa-plus fa-sm"></i> Agregar
                                            </CButton>
                                        </b-col>
                                        <b-col md="12 my-2">
                                            <b-table :items="listaIncidenciasNC.filter(x => x.estado == 2)" :fields="camposNoConformidades" class="table-custom" show-empty mediun responsive outlined fixed hover empty-text="Aún no hay datos en esta sección.">
                                                <template v-slot:cell(index)="data">{{ data.index + 1 }}</template>
                                                <template v-slot:cell(noConformidad)="data">
                                                    <validation-provider :name="'no_conformidad'" rules="required" v-slot="{errors}">
                                                        <v-select label="noConformidad" :reduce="comboNoConformidades =>comboNoConformidades.idNoConformidad" placeholder="Seleccione una opción" :class=" {'style-valid-select': data.item.idNoConformidad , 'style-invalid-select is-invalid': !!errors.length}" v-model="data.item.idNoConformidad" :options="comboNoConformidades" @search:blur="blurNoConformidad">
                                                            <span slot="no-options" class="text-muted">Busqueda no encontrada</span>
                                                        </v-select>
                                                    </validation-provider>
                                                </template>
                                                <template v-slot:cell(comentario)="data">
                                                    <validation-provider :name="'comentario'+data.index" :rules="{ required: true }" v-slot="validationContext">
                                                        <b-form-textarea rows="2" max-rows="6" placeholder="Ingrese comentario" :state="getValidationState(validationContext)" v-model="data.item.comentario"></b-form-textarea>
                                                    </validation-provider>
                                                </template>

                                                <template v-slot:cell(opciones)="param">
                                                    <b-button v-if="param" size="sm" variant="danger" v-c-tooltip.hover.click="'Eliminar'" @click="eliminarNoConformidad(param)">
                                                        <i class="fas fa-trash-alt  my-0 mx-0"></i>
                                                    </b-button>
                                                </template>
                                            </b-table>
                                        </b-col>
                                    </b-row>
                                </b-tab>

                                <b-col md="12" class="text-center my-2">
                                    <b-button :disabled="disabled" variant="dark" class=" mr-2" :to="{name: 'Incidencias'}">
                                        <i class="fas fa-arrow-left"></i> Volver
                                    </b-button>
                                    <b-button v-if="$route.params.id && checkPermissions('011-INC-INC','u')==1" :disabled="disabled" variant="success" type="submit">
                                        <i class="fas fa-save"></i> Guardar
                                    </b-button>
                                    <b-button v-if="!$route.params.id && checkPermissions('011-INC-INC','c')==1" :disabled="disabled" variant="success" type="submit">
                                        <i class="fas fa-save"></i> Guardar
                                    </b-button>
                                </b-col>
                            </b-tabs>

                        </b-form>

                    </validation-observer>
                </b-col>
            </b-row>
        </CCardBody>
    </CCard>

</div>
</template>

<script>
import axios from "axios";
import CONSTANTES from "@/Constantes.js";

export default {
    data() {
        return {
            disabled: false,
            datosIncidencia: {
                idCliente: '',
                idIncidencia: '',
                fecha: moment().format('YYYY-MM-DD'),
                numero: '',
                norma: null,
                tipo: null,
                categoria: null,
                idProceso: null,
                personaDetecta: '',
                isResuelta: 1,
                fechaResolucion: '',
                descripcion: '',
                observacion: ''
            },

            comboNorma: [{
                idNorma: 1,
                descripcion: "Calidad (9001)"
            }, {
                idNorma: 2,
                descripcion: "MedioAmbiente (14001)"
            }, {
                idNorma: 3,
                descripcion: "Seguridad Laboral (45001)"
            }, {
                idNorma: 4,
                descripcion: "AntiSoborno (37001)"
            }],
            comboTipo: [{
                idTipo: 1,
                descripcion: "Accidente"
            }, {
                idTipo: 2,
                descripcion: "Incidente"
            }],

            comboCategoria: [],
            comboProceso: [],
            radioResueltas: [{
                    value: "2",
                    text: "Si"
                },
                {
                    value: "1",
                    text: "No"
                },
            ],

            listaIncidenciasEvidencias: [],
            listaIncidenciasNC: [],

            camposEvidencias: [{
                    key: "index",
                    label: "N°",
                    class: "text-center",
                }, {
                    key: 'nombre',
                    label: 'Nombre',
                    class: 'text-center'
                },
                {
                    key: 'documento',
                    label: 'Fichero',
                    class: 'text-center'
                }, {
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
                }
            ],
            camposNoConformidades: [{
                    key: "index",
                    label: "N°",
                    class: "text-center",
                }, {
                    key: 'noConformidad',
                    label: 'No Conformidad',
                    class: 'text-center'
                },
                {
                    key: 'comentario',
                    label: 'Comentario',
                    class: 'text-center'
                }, {
                    key: 'opciones',
                    label: '',
                    class: 'text-center'
                }
            ],
            comboNoConformidades: [],
             accept: [
                '.vsd', '.vsdx', '.xlsx', '.xls', '.csv',
                '.pdf', '.doc', '.docx', '.ppt', '.pptx',
                '.png', '.jpg', '.jpeg', '.pdf', '.docx',
                'application/msword',
                'application/vnd.ms-excel'
            ],
        }
    },
    methods: {
        checkPermissions(code, crud) {
            return this.$store.state.permissions.filter(x => x.codigo == code)[0][crud]
        },
        getValidationState({
            dirty,
            validated,
            valid = null
        }) {
            return dirty || validated ? valid : null;
        },

        registrarIncidencia() {
            let me = this;
            me.disabled = true;

            const formData = new FormData();

            let data = 0;

            for (const i in me.listaIncidenciasEvidencias) {
                if (me.listaIncidenciasEvidencias[i].idIncidenciaEvidencia == 0 && me.listaIncidenciasEvidencias[i].documento != null) {
                    data = data - 1;
                    formData.append("filex" + data, me.listaIncidenciasEvidencias[i].documento);
                } else {
                    formData.append("filex" + me.listaIncidenciasEvidencias[i].idIncidenciaEvidencia, me.listaIncidenciasEvidencias[i].documento);
                };
            }
            formData.append("listaIncidenciasEvidencias", JSON.stringify(me.listaIncidenciasEvidencias));
            formData.append("listaIncidenciasNC", JSON.stringify(me.listaIncidenciasNC));

            formData.append("folder", 'incidentes/gestion-de-incidencias');

            /*---Datos del objeto--*/
            formData.append("idCliente", me.datosIncidencia.idCliente);

            formData.append("idIncidencia", me.datosIncidencia.idIncidencia);
            formData.append("fecha", me.datosIncidencia.fecha);
            formData.append("numero", me.datosIncidencia.numero);
            formData.append("norma", me.datosIncidencia.norma);
            formData.append("tipo", me.datosIncidencia.tipo);
            formData.append("categoria", me.datosIncidencia.categoria);
            formData.append("idProceso", me.datosIncidencia.idProceso);
            formData.append("personaDetecta", me.datosIncidencia.personaDetecta);
            formData.append("isResuelta", me.datosIncidencia.isResuelta);
            formData.append("fechaResolucion", me.datosIncidencia.fechaResolucion);
            formData.append("descripcion", me.datosIncidencia.descripcion);
            formData.append("observacion", me.datosIncidencia.observacion);

            axios
                .post(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/registrar-incidencias",
                    formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${localStorage.token}`
                        }
                    }
                )
                .then(function (response) {
                    let color = response.data.resultado == 1 ? "success" : "error";
                    me.swat(color, response.data.mensaje)
                    me.disabled = false;
                    me.$router.push({
                        name: 'Incidencias'
                    });
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                    me.disabled = false;
                });
        },
        handlexFileUpload(e, i) {
            if (!e.target.files[0]) {
                return;
            } else {
                if (!e.target.files[0].name.match(/\.(vsd|vsdx|xlsx|xls|csv|pdf|doc|docx|ppt|pptx|png|jpg|jpeg|pdf|docx)$/i)) {
                    this.swat('error', "Formato de archivo no admitido.");
                    this.$refs[`filex${i}`].reset();
                    return;
                }
                if (e.target.files[0].size > 20971520) {
                    this.swat('error', "El tamaño del archivo no debe ser superior a 20MB");
                    this.$refs[`filex${i}`].reset();
                    return;
                }
            }
        },
        agregarEvidencias() {
            this.listaIncidenciasEvidencias.push({
                idIncidenciaEvidencia: 0,
                nombre: '',
                documento: null,
                nombreArchivo: '',
                urlArchivo: '',
                estado: 2
            })
        },
        agregarNoConformidades() {
            this.listaIncidenciasNC.push({
                idIncidenciaNC: 0,
                idNoConformidad: '',
                comentario: '',
                estado: 2
            })
        },

        obtenerIncidencia() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/obtener-incidencia", {
                        params: {
                            idCliente: me.datosIncidencia.idCliente,
                            idIncidencia: me.$route.params.id
                        },
                    }
                )
                .then(function (response) {

                    me.datosIncidencia.idCliente = response.data[0].idCliente;
                    me.datosIncidencia.idIncidencia = response.data[0].idIncidencia;
                    me.datosIncidencia.fecha = response.data[0].fecha;
                    me.datosIncidencia.numero = response.data[0].numero;
                    me.datosIncidencia.norma = response.data[0].norma;
                    me.datosIncidencia.tipo = parseInt(response.data[0].tipo);
                    me.datosIncidencia.categoria = response.data[0].idCategoriaIncidente;
                    me.datosIncidencia.idProceso = response.data[0].idProceso;
                    me.datosIncidencia.personaDetecta = response.data[0].personaDetecta;
                    me.datosIncidencia.isResuelta = response.data[0].isResuelta;
                    me.datosIncidencia.fechaResolucion = response.data[0].fechaResolucion;
                    me.datosIncidencia.descripcion = response.data[0].descripcion;

                    me.datosIncidencia.observacion = response.data[0].observacion;
                    me.obtenerIncidenciaEvidencias();
                    me.obtenerIncidenciaNC();
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!');
                    me.$router.push({
                        name: 'Incidencias'
                    });
                });
        },
        listarNoConformidades() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/listar-no-conformidades", {
                    params: {
                        idCliente: me.datosIncidencia.idCliente,
                    }
                })
                .then(function (response) {
                    me.comboNoConformidades = response.data;
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                    me.$router.push({
                        name: 'Incidencias'
                    });
                });
        },
        obtenerIncidenciaEvidencias() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/obtener-incidencia-evidencias", {
                        params: {
                            idCliente: me.datosIncidencia.idCliente,
                            idIncidencia: me.datosIncidencia.idIncidencia
                        },
                    }
                )
                .then(function (response) {
                    me.listaIncidenciasEvidencias = response.data
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!');
                    me.$router.push({
                        name: 'Incidencias'
                    });
                });
        },
        obtenerIncidenciaNC() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/obtener-incidencia-no-conformidades", {
                        params: {
                            idCliente: me.datosIncidencia.idCliente,
                            idIncidencia: me.datosIncidencia.idIncidencia
                        },
                    }
                )
                .then(function (response) {
                    me.listaIncidenciasNC = response.data
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!');
                    me.$router.push({
                        name: 'Incidencias'
                    });
                });
        },
        blurNorma() {
            this.computedForm.refs.norma.validate();
        },
        blurNoConformidad() {
            this.computedForm.refs.no_conformidad.validate();
        },
        blurTipo() {
            this.computedForm.refs.tipo.validate();
        },
        blurCategoria() {
            this.computedForm.refs.categoria.validate();
        },
        blurProceso() {
            this.computedForm.refs.proceso.validate();
        },
        registrarEvidencia() {
            let me = this;
            me.listaIncidenciasEvidencias.push({
                nombre: me.datosEvidencia.nombre
            })
        },
        listarProcesos() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/listar-procesos", {
                        params: {
                            idCliente: me.datosIncidencia.idCliente
                        },
                    }
                )
                .then(function (response) {

                    me.comboProceso = response.data
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                });
        },
        listarCategorias() {
            let me = this;
            axios.defaults.headers.common[
                "Authorization"
            ] = `Bearer ${localStorage.token}`;
            axios
                .get(
                    CONSTANTES.URL_RUTA_SERVICIOS + "coordinador/listar-categorias-incidentes", {
                        params: {
                            idCliente: me.datosIncidencia.idCliente
                        },
                    }
                )
                .then(function (response) {
                    me.comboCategoria = response.data;
                })
                .catch(function (error) {
                    me.swat('error', 'Algo salió mal!')
                });
        },
        swat(icon, title) {
            this.$swal.mixin({
                toast: true,
                showConfirmButton: false,
                position: 'bottom-right',
                timer: 3500,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            }).fire({
                icon: icon,
                title: title
            });
        },
        eliminarEvidencia(param) {
            let me = this;
            if (me.$route.params.id) {
                let lista = me.listaIncidenciasEvidencias.filter(x => x.estado == 2);
                if (lista[param.index].idIncidenciaEvidencia != 0) {
                    lista[param.index].estado = 1
                } else if (lista[param.index].idIncidenciaEvidencia == 0) {
                    lista[param.index].estado = 0
                    for (let e in me.listaIncidenciasEvidencias) {
                        if (me.listaIncidenciasEvidencias[e].estado == 0) {
                            me.listaIncidenciasEvidencias.splice(e, 1);
                        }
                    }
                }
            } else {
                me.listaIncidenciasEvidencias.splice(param.index, 1)
            }
        },
        eliminarNoConformidad(param) {
            let me = this;
            if (me.$route.params.id) {
                let lista = me.listaIncidenciasNC.filter(x => x.estado == 2);
                if (lista[param.index].idIncidenciaNC != 0) {
                    lista[param.index].estado = 1
                } else if (lista[param.index].idIncidenciaNC == 0) {
                    lista[param.index].estado = 0
                    for (let e in me.listaIncidenciasNC) {
                        if (me.listaIncidenciasNC[e].estado == 0) {
                            me.listaIncidenciasNC.splice(e, 1);
                        }
                    }
                }
            } else {
                me.listaIncidenciasNC.splice(param.index, 1)
            }
        },
        resetModalRegistrarEvidencia() {
            this.$nextTick(() => {
                this.$refs.observer2.reset();
            });
            this.datosEvidencia.nombre = '';
        }
    },
    computed: {
        computedForm() {
            return this.$refs.observer;
        }
    },
    mounted() {
        if (this.$store.state.user) {
            let user = this.$store.state.user;
            this.datosIncidencia.idCliente = user.uidClient;
            this.listarProcesos();
            this.listarCategorias();
            this.listarNoConformidades();

            if (this.$route.params.id) {
                this.obtenerIncidencia();
            }
        }
    }

}
</script>
